<template>
  <div
    class="
      bg-white
      h-fit
      w-[350px]
      rounded-lg
      px-3
      py-4
      drop-shadow-lg
      md:w-[350px]
      md:p-4
    "
  >
    <p class="pig mb-3 !font-bold">
      {{ $t("checkout.input.cvvCheck.tooltipTitle") }}
    </p>

    <p class="beaver">
      {{ $t("checkout.input.cvvCheck.tooltipDescription") }}
    </p>
  </div>
</template>
